<template>
  <div class="page-container md-layout-column">

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <md-content>

      <md-field :class="messageClass">
        <md-icon>input</md-icon>
        <label for="transfer_type">Тип переноса</label>
        <md-select v-model="statusOptions.shift_type" name="transfer_type" id="transfer_type">
          <md-option value="uncall"> Курьер не дозвонился</md-option>
          <md-option value="client_request"> По просьбе получателя</md-option>
          <md-option value="wrong_address"> Не верный адрес</md-option>
          <md-option value="courier_late"> Курьер не успел</md-option>
          <md-option value="wrong_phone"> Не верный телефон</md-option>
          <md-option value="client_is_absent"> Получателя не оказалось на адресе</md-option>
          <md-option value="wrong_summ"> Не верная сумма</md-option>
          <md-option value="place"> Получателя нет на месте</md-option>
        </md-select>
      </md-field>

      <md-datepicker :class="messageClass"
                     v-if="this.shiftTypes.indexOf(statusOptions.shift_type) > -1"
                     v-model="statusOptions.date_shift"
                     :md-disabled-dates="isDateDisabled" :md-model-type="String">
        <label>Дата переноса</label>
      </md-datepicker>

      <md-field :class="messageClass"
                v-if="statusOptions.date_shift && this.shiftTypes.indexOf(statusOptions.shift_type) > -1">
        <md-icon>input</md-icon>
        <label for="intervals">Интервал</label>
        <md-select v-model="statusOptions.date_shift_interval" name="intervals" id="intervals">
          <md-option v-for="(item, index) in order.allowDeliveryDatesAndIntervals[statusOptions.date_shift]"
                     :value="item">
            {{item}}
          </md-option>
        </md-select>
      </md-field>

      <md-field :class="messageClass" v-if="statusOptions.shift_type === 'uncall'">
        <md-icon>input</md-icon>
        <label for="un_call_type">Причина недозвона</label>
        <md-select v-model="statusOptions.reason_call_fail" name="un_call_type" id="un_call_type">
          <md-option value="Недоступен"> Недоступен</md-option>
          <md-option value="Не берет трубку"> Не берет трубку</md-option>
          <md-option value="Номер не существует"> Номер не существует</md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Комментарий: </label>
        <md-textarea v-model="statusOptions.comment"/>
      </md-field>

      <md-dialog-confirm
        :md-active.sync="showSetStatusDialog"
        md-title="Установить статус?"
        :md-content="dialogMsg"
        md-confirm-text="Установить"
        md-cancel-text="Отмена"
        @md-cancel="onCancel"
        @md-confirm="setStatus"/>
      <md-button class="md-raised md-accent" @click="createDialog">Установить статус</md-button>
    </md-content>
  </div>
</template>

<script>
  export default {
    name: "Transfer",
    props: ['order'],
    data() {
      return {
        showSetStatusDialog: false,
        dialogMsg: '',
        lightInputs: false,
        statusOptions: {
          shift_type: '',
          date_shift: null,
          date_shift_interval: '',
          reason_call_fail: '',
          comment: '',
        },
        shiftTypes: ['client_request','wrong_address','courier_late','wrong_phone','client_is_absent','wrong_summ'],
      }
    },
    mounted() {
      this.$material.locale.firstDayOfAWeek = 1
    },
    methods: {
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      isDateDisabled: function (date) {
        // true - выключена
        // 2020-03-27
        let month = String(date.getMonth() + 1);
        if (month.length === 1) month = '0' + month;

        let day = String(date.getDate());
        if (day.length === 1) day = '0' + day;

        let tdDateString = date.getFullYear() + "-" + month + "-" + day;
        return !this.$props.order.allowDeliveryDatesAndIntervals.hasOwnProperty(tdDateString)
      },
      setStatus() {
        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: "setOrderTransferStatus",
          id: this.$props.order.order.Id,
          shift_type: this.statusOptions.shift_type,
          date_shift: this.statusOptions.date_shift,
          date_shift_interval: this.statusOptions.date_shift_interval,
          reason_call_fail: this.statusOptions.reason_call_fail,
          comment: this.statusOptions.comment,
        }));
      },
      onCancel() {
        this.showSetStatusDialog = false
      },
      createDialog() {

        if (this.statusOptions.shift_type === 'uncall') {
          this.dialogMsg = 'Перенести доставку по причине "' + this.statusOptions.reason_call_fail + '"?';
          //this.dialogMsg = `Перенести доставку по причине "${this.statusOptions.reason_call_fail}"?`;
        } else if (this.statusOptions.shift_type === 'place') {
          this.dialogMsg = 'Перенести доставку по причине "Получателя нет на месте"?';
        } else if (this.statusOptions.shift_type !== '') {
          this.dialogMsg = 'Перенести доставку на "' + this.statusOptions.date_shift + '" интервал "' + this.statusOptions.date_shift_interval + '"?';
        }

        this.showSetStatusDialog = true
      },
    },
    computed: {
      currentDate: function () {
        const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return new Date().toLocaleDateString(undefined, options)
      },
      error() {
        let err = this.$store.getters.getErrorByMethod('setStatus');
        if (err.show) this.lightInputs = true;
        return err
      },
      messageClass() {
        return {
          'md-invalid': this.lightInputs
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Status/Transfer.vue